import { TicketConfirmationIcon } from './TicketConfirmationIcon';

/**
 * author: Google
 * id F19DA1EC-CBDA-456E-BC19-F03C635C886F
 * name ticket-confirmation
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ticket-confirmation.svg
 * tags
 */
export const ConfirmationNumberIcon = TicketConfirmationIcon;
export default ConfirmationNumberIcon